
const styles = require('./styles.css')
const scripts = require('./app._js')

module.exports = json =>
    '<!-- WARNING: do not edit this document directly -->\n' +
    '<!-- it was generated with the ops cli and may be overwritten -->\n\n' +
    '<!DOCTYPE html>' +
    '<html>' +
        '<head>' +
            '<meta charset="utf-8">' +
            '<title>ops client documentation</title>' +
            '<link href="https://fonts.googleapis.com/css?family=Roboto+Mono" rel="stylesheet">' +
            '<link rel="stylesheet"  href="https://cdnjs.cloudflare.com/ajax/libs/normalize/7.0.0/normalize.min.css" />' +
        '</head>' +
        '<body>' +
            '<style media="screen">' + styles + '</style>' +

            '<div id="app"></div>' +
            '<script crossorigin src="https://unpkg.com/react@16/umd/react.production.min.js"></script>' +
            '<script crossorigin src="https://unpkg.com/react-dom@16/umd/react-dom.production.min.js"></script>' +
            '<script type="text/javascript">' +
                'window.docsData = ' + JSON.stringify(json) + ';' +
                scripts +
            '</script>' +

        '</body>' +
    '</html>'



// WEBPACK FOOTER //
// ./src/templates/docs_app/index.js